import type { ReactElement } from 'react'
import { Dropdown } from '~/components/Form'
import type { SingleDropdownProps } from '~/components/Form/Input/Dropdown'
import { Badge } from '~/components/Global/Blocks/Badge/Badge'
import type { TaxonomyItems } from '~/domains/taxonomies/types'

type OrderStatusDropdownProps = Omit<SingleDropdownProps, 'options'> & {
  statuses: TaxonomyItems<'applicant_order_statuses'> | undefined
}

export const OrderStatusDropdown = ({
  statuses,
  placeholder = 'Choisir un statut',
  ...rest
}: OrderStatusDropdownProps): ReactElement => {
  return (
    <Dropdown
      options={
        statuses?.map((status) => ({
          label: status.name,
          value: String(status.id),
          element: <Badge title={status.name} backgroundColor={status.color} />
        })) || []
      }
      placeholder={placeholder}
      {...rest}
    />
  )
}
